import { render, staticRenderFns } from "./Competitors.vue?vue&type=template&id=08794a9b&scoped=true"
import script from "./Competitors.vue?vue&type=script&lang=js"
export * from "./Competitors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08794a9b",
  null
  
)

export default component.exports